export default {"src":"/_next/static/media/chevronRight_16.006cdfbc.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};